import {useCallback, useEffect} from 'react';
import debounce from 'lodash/debounce';

const useDebouncedEffect = (effect, delay, deps, options = {}) => {
  const debounceEffect = debounce(effect, delay, options);
  const callback = useCallback(debounceEffect, deps);

  useEffect(() => {
    callback();
    return () => debounceEffect.cancel();
  }, [callback, delay]);
};

export default useDebouncedEffect;
